<template>
  <v-card>
    <v-flex xs12 sm12 md12 lg12 ml-3 pt-2 mb-2>
      <v-icon @click="routeTo(0)" style="font-size: 20px;">home</v-icon>
      <span v-for="(breadcrumb, idx) in breadcrumbList" :key="idx" @click="routeTo(idx)">
        <span class="grey--text text--darken-1" style="font-size: 16; font-weight: bold;">
          <v-icon style="font-size: 16px;">chevron_right</v-icon>
          <template v-if="breadcrumb.link != null">
            <a> {{ breadcrumb.name }} </a>
          </template>
        </span>
      </span>
      <h1 class="ml-3 mt-2"> {{ pageTitle }} </h1>
    </v-flex>
    <v-divider />
    <component v-if="currentPage" :is="currentPage.component" v-bind="currentPageAttributes" @navigate="onNavigate"
      @setPageTitle="setPageTitle">
    </component>
  </v-card>
</template>

<script>
  import registeredModules from './store/registeredModules'
  import pages from './config/pages'
  export default {
    props: {
      service: Object,
    },
    data() {
      return {
        currentPage: pages.configurationSettingsList,
        currentPageAttributes: {},
        pages: pages,
        breadcrumbList: [],
        overridePageTitle: null,
      }
    },
    computed: {
      pageTitle() {
        return this.overridePageTitle || this.breadcrumbList && this.breadcrumbList.length && this.breadcrumbList[this
            .breadcrumbList.length - 1]
          .name
      },
    },
    watch: {
      currentPage() {
        this.breadcrumbList = this.currentPage.meta.breadcrumb
      },
    },
    mounted() {
      this.breadcrumbList = this.currentPage.meta.breadcrumb
    },
    methods: {
      onNavigate({
        path,
        props,
      }) {
        if (path == null) {
          return
        }
        if (pages[path] == null) {
          return
        }
        this.currentPage = pages[path]
        this.currentPageAttributes = props || {}
        this.overridePageTitle = null
      },
      routeTo(breadCrumbIdx) {
        let breadCrumbLink = this.breadcrumbList[breadCrumbIdx].link
        if (breadCrumbLink) {
          this.onNavigate({
            path: breadCrumbLink,
            props: null,
          })
        }
      },
      setPageTitle({
        pageTitle,
      }) {
        this.overridePageTitle = pageTitle
      },
    },
    beforeCreate() {
      Object.entries(registeredModules).forEach(([key, value]) => {
        console.log('registering module', key, value)
        this.$store.registerModule(key, value)
      })

    },
    beforeDestroy() {
      Object.entries(registeredModules).forEach(([key]) => this.$store.unregisterModule(key))
    },

  }

</script>
